export class ReportType {
    public reportTypeId: number;
    public reportTypeName: string;

    constructor(init?: Partial<ReportType>) {
        this.reportTypeId = init.reportTypeId;
        this.reportTypeName = init.reportTypeName;
    }
}
